import { render, staticRenderFns } from "./sidebar-QRcode.vue?vue&type=template&id=07710e1a&scoped=true"
import script from "./sidebar-QRcode.vue?vue&type=script&lang=js"
export * from "./sidebar-QRcode.vue?vue&type=script&lang=js"
import style0 from "./sidebar-QRcode.vue?vue&type=style&index=0&id=07710e1a&prod&scoped=true&lang=scss"
import style1 from "./sidebar-QRcode.vue?vue&type=style&index=1&id=07710e1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07710e1a",
  null
  
)

export default component.exports